import { trimTrailingSlash } from 'utils';
import { Config } from './types/config';

const resolveGraphApiUrl = (): string => {
  if (process.env.REACT_APP_GRAPH_API_URL) {
    return trimTrailingSlash(process.env.REACT_APP_GRAPH_API_URL);
  }

  return 'https://graph.ti.replicon.com/graphql';
};

export const CORE_CLIENT_ID = 'f5d4d830702b4dae9b4c2835ff5e93c0';

const config: Config = {
  gssUrl: trimTrailingSlash(
    process.env.REACT_APP_GSS_URL || 'https://global.replicon.com'
  ),
  stsUrl: trimTrailingSlash(
    process.env.REACT_APP_STS_URL || 'https://zt.replicon.com'
  ),
  sentryDsn:
    process.env.REACT_APP_SENTRY_DSN ||
    'https://c30293da84004a71b1a6ee37e8357110@o29628.ingest.sentry.io/5689389',
  graphApiUrl: resolveGraphApiUrl(),
  authorizePath: '/oauth/authorize',
  tokenPath: '/oauth/token',
  metricsPath: '/api/metrics',
  clientId:
    process.env.REACT_APP_REPLICON_CLIENT_ID ||
    '40d4f621f61d4d8d8226533cfe724838',
  clientSecret:
    process.env.REACT_APP_REPLICON_CLIENT_SECRET ||
    'hxdUX8OQ7ir9cyifCUwiFzICvQ0zKp_dJs7tS89_TjY',
  downloads: {
    windows:
      'https://zt.replicon.com/time-intelligence-desktop/windows/latest/ZeroTime%20Desktop%20Setup.exe',
    linux:
      'https://zt.replicon.com/time-intelligence-desktop/linux/latest/ZeroTime%20Desktop.AppImage',
    mac:
      'https://zt.replicon.com/time-intelligence-desktop/mac/latest/ZeroTime%20Desktop-universal.dmg'
  },
  desktopSupportedOSVersions: {
    macos: 'Mac OS X 10.13',
    windows: 'Windows 7'
  },
  ldClientId: process.env.REACT_APP_LD_CLIENT_ID || '5a9f210cd9a4d9203164dd81',
  allowedSessionDomains:
    process.env.REACT_SESSION_ALLOWED_DOMAINS || '.replicon.com'
};

export default config;
